import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUser from './user.reducer';

export const selectUserState = createFeatureSelector<fromUser.State>(
  fromUser.userFeatureKey
);

export const getUser = createSelector(selectUserState, (state, payload) =>
  state.users.find((user) => user.id === payload.userId)
);

export const getAllUser = createSelector(
  selectUserState,
  (state) => state.users
);

export const getUserProfile = createSelector(
  selectUserState,
  (state) => state.userProfile
);
